import { render, staticRenderFns } from "./PieChartWidget.vue?vue&type=template&id=071d15c3&scoped=true"
import script from "./PieChartWidget.vue?vue&type=script&lang=js"
export * from "./PieChartWidget.vue?vue&type=script&lang=js"
import style0 from "./PieChartWidget.vue?vue&type=style&index=0&id=071d15c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d15c3",
  null
  
)

export default component.exports